import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Breadcum from "../../components/breadcum";

export default function Home() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const images = [
    "/img/landing/about1.webp",
    "/img/landing/about2.webp",
    "/img/landing/about3.webp",
    "/img/landing/about4.webp",
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  // Preload images
  useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [images]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="bg-neutral-100">
      <div className="mx-auto max-w-screen-2xl py-36 px-6 lg:px-8 text-gray-900 flex flex-col md:flex-row items-center justify-center">
        <div className="md:w-1/2 text-left" data-aos="fade-up">
          <Breadcum text={"Nosotros"} />
          <h1
            className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Elevando los estándares de seguridad.
          </h1>

          <p
            className="text-gray-600 mt-4 mr-5"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            En Border Protect Seguridad Privada, nos dedicamos a ofrecer
            soluciones integrales de seguridad y vigilancia profesional. Nuestra
            misión es proteger los bienes y la integridad de nuestros clientes
            mediante un equipo de guardias altamente capacitados y protocolos de
            seguridad modernos.
          </p>

          <p
            className="text-gray-600 mt-4 mr-5"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Con años de experiencia en la industria, brindamos protección a
            empresas, instituciones y eventos. Nos destacamos por nuestro
            compromiso con la excelencia, la ética y la confianza en cada uno de
            nuestros servicios. Nuestro equipo se encuentra en constante
            capacitación para garantizar una seguridad más eficiente y adaptada
            a las necesidades actuales.
          </p>

          <div data-aos="zoom-in" data-aos-delay="400">
            <button className="mt-8 flex items-center px-6 py-4 text-base border border-red-600 font-semibold rounded-lg bg-red-600 text-white transition-all duration-300 shadow-lg hover:-translate-y-2">
              Solicita una Cotización Gratis
            </button>
          </div>
        </div>

        {/* Imagen con fade transition */}
        <div
          className="md:w-1/2 flex justify-center mt-8 md:mt-0 relative"
          data-aos="zoom-in"
        >
          <div className="relative w-full h-[420px] overflow-hidden">
            {images.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Imagen ${index + 1}`}
                className={`absolute top-0 left-0 w-full h-full object-cover clip-path-custom transition-opacity duration-1000 ${
                  index === activeIndex ? "opacity-100 z-10" : "opacity-0 z-0"
                }`}
              />
            ))}

            {/* Puntos de navegación */}
            <div className="absolute top-1/2 right-4 transform -translate-y-1/2 flex flex-col space-y-2 z-20">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full ${
                    activeIndex === index ? "bg-red-600" : "bg-gray-400"
                  } transition-all duration-300`}
                ></button>
              ))}
            </div>
          </div>

          <div
            className="absolute -bottom-3 right-0 bg-[#23346E] text-white text-xl font-bold uppercase p-6 w-64 z-20"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <p className="tracking-wide leading-tight">
              "Tu Protección, <br /> Nuestra Prioridad."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
